const START_CHUNK_SIZE = 8 * 1024 * 1024;
const START_MULTIPART_SIZE = START_CHUNK_SIZE * 2;
const MAX_CHUNK_SIZE = 5 * 1024 * 1024 * 1024;
const MAX_PARTS = 900;
const CHUNK_MULT = 64;
const SIZE_BREAK1 = START_CHUNK_SIZE * MAX_PARTS;
const SIZE_BREAK2 = START_CHUNK_SIZE * CHUNK_MULT * MAX_PARTS;

exports.calcChunkSize = calcChunkSize;
exports.START_MULTIPART_SIZE = START_MULTIPART_SIZE;

function calcChunkSize(size) {
  let chunk_size;
  if (size <= START_MULTIPART_SIZE) {
    chunk_size = START_MULTIPART_SIZE;
  } else if (size <= SIZE_BREAK1) {
    chunk_size = START_CHUNK_SIZE;
  } else if (size <= SIZE_BREAK2) {
    chunk_size = START_CHUNK_SIZE * CHUNK_MULT;
  } else {
    chunk_size = MAX_CHUNK_SIZE;
  }
  return chunk_size;
}
